// A message for the sign-in or sign-up page to show once, left by a flow that ends somewhere else

const KEY = 'lureo_auth_notice';

export interface AuthNotice {
  message: string;
  tone: 'error' | 'info';
}

export function leaveAuthNotice(notice: AuthNotice): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(notice));
  } catch {
    // Storage blocked: the page shows nothing, as before
  }
}

export function peekAuthNotice(): AuthNotice | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    const notice = raw ? (JSON.parse(raw) as Partial<AuthNotice>) : null;
    if (!notice || typeof notice.message !== 'string') return null;
    return { message: notice.message, tone: notice.tone === 'info' ? 'info' : 'error' };
  } catch {
    return null;
  }
}

export function forgetAuthNotice(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Storage blocked: there is nothing to forget
  }
}
